import styled from 'styled-components';
import {
  Wrapper as SearchBar
} from 'components/Input/styles'

export const Content = styled.section`
  height: 100%;
  padding: 3.2rem 3.2rem 0 3.2rem;

  ${SearchBar} {
    width: 100%;
    margin: .4rem 0 1.2rem 0;
  }

  &.allCenter {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: .8rem;
  margin-bottom: 2.4rem;
`;